import { ThemeProvider, CssBaseline } from '@mui/material';
import { getTheme } from './shared/config/theme';
import Router from './shared/routes/Router';
import { AuthProvider } from './modules/auth';
import { ModalProvider } from './shared/context/ModalContext';
import { ThemeModeProvider } from './shared/context/ThemeModeContext';
import { TenantProvider } from './shared/context/TenantContext';
import { ToastProvider } from './shared/context/ToastContext';
import { useEffect } from 'react';
import { useToast } from './shared/hooks/useToast';
import { ErrorBoundaryWithToast } from './shared/components/ErrorBoundary';

function App() {

  return (
    <ThemeModeProvider>
      <CssBaseline />
      <TenantProvider>
        <AuthProvider>
          <ToastProvider>
            <ModalProvider>
         
                <ErrorBoundaryWithToast>
                  <Router />
                </ErrorBoundaryWithToast>
            
            </ModalProvider>
          </ToastProvider>
        </AuthProvider>
      </TenantProvider>
    </ThemeModeProvider>
  );
}

export default App;